// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a4-3";
export var contentContainer = "_a4-0";
export var editorContainer = "_a4-1";
export var quillInputForm = "_a4-2";
export var zoneDivider = "_a4-4";